(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["afiba-business-page"] && !Shopify.designMode) return;
  try {
    
function initAfibaBusiness(root){
 if(root.dataset.ready) return;
 root.dataset.ready='true';
 root.querySelectorAll('[data-b2b-service]').forEach(link=>link.addEventListener('click',()=>{
  const select=root.querySelector('[data-b2b-service-select]');
  if(select) select.value=link.dataset.b2bService;
 }));
 root.querySelectorAll('[data-b2b-interest]').forEach(link=>link.addEventListener('click',()=>{
  const check=[...root.querySelectorAll('[data-interest]')].find(input=>input.dataset.interest===link.dataset.b2bInterest);
  if(check) check.checked=true;
 }));
}
document.querySelectorAll('[data-afiba-business]').forEach(initAfibaBusiness);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-afiba-business]').forEach(initAfibaBusiness));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["afiba-magic-duo-home"] && !Shopify.designMode) return;
  try {
    
function initSheaOffer(root){
  root.querySelectorAll('[data-shea-offer]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const form=section.querySelector('[data-offer-form]');
    form.addEventListener('change',event=>{
      if(event.target.type!=='radio')return;
      section.querySelector('[data-offer-price]').textContent=event.target.dataset.price;
      const image=section.querySelector('[data-offer-image]');
      if(image){image.src=event.target.dataset.image;image.alt=event.target.dataset.alt;}
    });
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('button');
      if(button.disabled)return;
      const original=button.textContent;
      const error=section.querySelector('[data-offer-error]');
      error.hidden=true;button.disabled=true;button.textContent=form.dataset.loading;
      try{
        const response=await fetch(form.action+'.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
        if(!response.ok)throw new Error('cart');
        window.location.assign(form.elements.return_to.value);
      }catch(e){error.textContent=form.dataset.error;error.hidden=false;button.disabled=false;button.textContent=original;}
    });
  });
}
initSheaOffer(document);
document.addEventListener('shopify:section:load',event=>initSheaOffer(event.target));

  } catch(e) { console.error(e); }
})();
})();
